import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_URL } from "../../../config";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import "./EmployeeListPage.css";

export default function EmployeeListPage() {
  const [list, setList] = useState([]);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  useEffect(() => {
    const delay = setTimeout(() => setDebouncedSearch(search), 200);
    return () => clearTimeout(delay);
  }, [search]);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/employeeListProject`)
      .then((res) => setList(res.data))
      .catch((err) => console.log(err));
  }, []);

  const filteredList = list.filter((emp) => {
    const q = debouncedSearch.toLowerCase();

    return (
      emp.employeeName?.toLowerCase().includes(q) ||
      emp.projectName?.toLowerCase().includes(q) ||
      emp.clientName?.toLowerCase().includes(q) ||
      emp.status?.toLowerCase().includes(q) ||
      String(emp.startDate)?.toLowerCase().includes(q) ||
      String(emp.endDate)?.toLowerCase().includes(q)
    );
  });

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(filteredList);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Employees");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const file = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(file, "Employee_Project_List.xlsx");
  };

  const total = list.length || 1;

  const completed = list.filter((e) => e.status === "Completed").length;
  const inProgress = list.filter((e) => e.status === "In Progress").length;
  const pending = list.filter((e) => e.status !== "Completed" && e.status !== "In Progress").length;

  const completedPercent = (completed / total) * 100;
  const inProgressPercent = (inProgress / total) * 100;
  const pendingPercent = (pending / total) * 100;

  const formatDate = (value) => {
    if (!value) return "-";
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? value : d.toLocaleDateString();
  };

  return (
    <div className="emp-proj-page">
      <div className="emp-proj-shell">
        <div className="emp-proj-hero">
          <div>
            <p className="emp-proj-eyebrow">Team Allocation</p>
            <h5>Employees & Projects</h5>
            <span>Track assignment pipeline, delivery status, and timelines</span>
          </div>

          <button onClick={exportToExcel} className="emp-proj-export-btn">
            Export Excel
          </button>
        </div>

        <div className="emp-proj-search-card">
          <input
            type="text"
            placeholder="Search employee, project, client, status..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="emp-proj-search-input"
          />
        </div>

        <div className="emp-proj-status-card">
          <div className="emp-proj-status-bar">
            <div
              className="seg-completed"
              style={{ width: `${completedPercent}%` }}
              title={`Completed: ${completed}`}
            />
            <div
              className="seg-progress"
              style={{ width: `${inProgressPercent}%` }}
              title={`In Progress: ${inProgress}`}
            />
            <div
              className="seg-pending"
              style={{ width: `${pendingPercent}%` }}
              title={`Pending: ${pending}`}
            />
          </div>

          <div className="emp-proj-legend">
            <span><i className="dot completed" /> Completed ({completed})</span>
            <span><i className="dot progress" /> In Progress ({inProgress})</span>
            <span><i className="dot pending" /> Pending ({pending})</span>
          </div>
        </div>

        <div className="emp-proj-table-card">
          <div className="emp-proj-table-wrap">
            <table className="table align-middle mb-0">
              <thead>
                <tr>
                  {["Employee", "Project", "Client", "Status", "Start", "End", "View"].map((h, i) => (
                    <th key={i}>{h}</th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {filteredList.map((emp) => {
                  const statusClass = String(emp.status || "").toLowerCase().replace(/\s+/g, "-");

                  return (
                    <tr key={emp.employeeId}>
                      <td className="emp-name">{emp.employeeName}</td>
                      <td>{emp.projectName || "-"}</td>
                      <td>{emp.clientName || "-"}</td>
                      <td>
                        <span className={`emp-status-chip status-${statusClass}`}>{emp.status || "-"}</span>
                      </td>
                      <td>{formatDate(emp.startDate)}</td>
                      <td>{formatDate(emp.endDate)}</td>

                      <td>
                        <Link to={`/admin/EmployeeTasks/${emp.employeeId}`} className="emp-view-btn">
                          View Tasks
                        </Link>
                      </td>
                    </tr>
                  );
                })}

                {filteredList.length === 0 && (
                  <tr>
                    <td colSpan="7" className="emp-empty-cell">
                      No matching records found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
